import * as AdminPPType from "../../action/actiontype/AdminPPType/AdminPPType";

const adminPPReducer = (state = {}, action) => {
    switch (action.type) {
        case AdminPPType.ADMINPP_LIST_REQUEST:
            return {
                ...state,
                adminPPLoading: true,
                adminPPResponse: {},
                adminPPError: null
            } 
        case AdminPPType.ADMINPP_LIST_SUCCESS:
            return {
                ...state,
                adminPPLoading: false,
                adminPPResponse: action.payload,
                // adminPPResponse: [],
                adminPPError: null
            }
        case AdminPPType.ADMINPP_LIST_FAILURE:
            return {
                ...state,
                adminPPLoading: false,
                adminPPError: action.payload,
                adminPPResponse: {}
            }
        case AdminPPType.ADMINPPLIST:
            return{
                ...state,
                adminppList:action.payload
            }
            // admin pp add

            case AdminPPType.ADMINPP_ADD_REQUEST:
                return {
                    ...state,
                    adminPPAddLoading: true,
                    adminPPAddResponse: {},
                    adminPPAddError: null
                } 
            case AdminPPType.ADMINPP_ADD_SUCCESS:
                return {
                    ...state,
                    adminPPAddLoading: false,
                    adminPPAddResponse: action.payload,
                    // adminPPResponse: [],
                    adminPPAddError: null
                }
            case AdminPPType.ADMINPP_ADD_FAILURE:
                return {
                    ...state,
                    adminPPAddLoading: false,
                    adminPPAddError: action.payload,
                    adminPPAddResponse: {}
                }
            // admin pp edit

            case AdminPPType.ADMINPP_EDIT_REQUEST:
                return {
                    ...state,
                    adminPPEditLoading: true,
                    adminPPEditResponse: {},
                    adminPPEditError: null
                } 
            case AdminPPType.ADMINPP_EDIT_SUCCESS:
                return {
                    ...state,
                    adminPPEditLoading: false,
                    adminPPEditResponse: action.payload,
                    // adminPPResponse: [],
                    adminPPEditError: null
                }
            case AdminPPType.ADMINPP_EDIT_FAILURE:
                return {
                    ...state,
                    adminPPEditLoading: false,
                    adminPPEditError: action.payload,
                    adminPPEditResponse: {}
                }

              case AdminPPType.ADMINPP_GETID_REQUEST:
                    return {
                        ...state,
                        adminPPGetIdLoading: true,
                        adminPPGetIdResponse: {},
                        adminPPGetIdError: null
                    } 
             case AdminPPType.ADMINPP_GETID_SUCCESS:
                    return {
                        ...state,
                        adminPGetIdLoading: false,
                        adminPPGetIdResponse: action.payload,
                        // adminPPResponse: [],
                        adminPPGetIdError: null
                    }
              case AdminPPType.ADMINPP_GETID_FAILURE:
                    return {
                        ...state,
                        adminPPGetIdLoading: false,
                        adminPPGetIdError: action.payload,
                        adminPPGetIdResponse: {}
                    }
                    // Update status

                    case AdminPPType.ADMIN_STATUS_REQUEST:
                        return {
                            ...state,
                            adminStatusLoading: true,
                            adminStatusResponse: {},
                            adminStatusError: null
                        } 
                    case AdminPPType.ADMINPP_STATUS_SUCCESS:
                        return {
                            ...state,
                            adminStatusLoading: false,
                            adminStatusResponse: action.payload,
                            // adminPPResponse: [],
                            adminStatusError: null
                        }
                    case AdminPPType.ADMINPP_STATUS_FAILURE:
                        return {
                            ...state,
                            adminStatusLoading: false,
                            adminStatusResponse: action.payload,
                            adminStatusError: {}
                        }    

        default:
            return state;
    }
}

export default adminPPReducer;
